import { motion, useScroll, useTransform } from "framer-motion";

export function ScrollThread() {
  const { scrollYProgress } = useScroll();
  const top = useTransform(scrollYProgress, (v) => `${v * 100}%`);

  return (
    <div className="fixed left-5 top-0 bottom-0 hidden lg:block z-30 pointer-events-none" aria-hidden="true" data-testid="scroll-thread">
      <div className="absolute inset-y-0 left-0 w-px bg-line" />
      <motion.div className="absolute inset-y-0 left-0 w-px bg-ember origin-top" style={{ scaleY: scrollYProgress }} />
      <motion.div
        className="absolute -left-[3px] w-[7px] h-[7px] rounded-full bg-ember"
        style={{ top }}
      />
    </div>
  );
}
